import { useSession } from 'next-auth/react';
import { FC, useMemo } from 'react';
import { ButtonProps } from '@components/UIKit/Button/Button';
import { useIsFollowing } from '@hooks/TRPC_Hooks/useIsFollowing';
import { SocialManagerView } from '@specs/views';
import { EditButton } from '../Buttons/EditButton';
import { FollowButton } from '../Buttons/FollowButton';
import { FollowingButtons } from '../Buttons/FollowingButton';
import { LoadingButton } from '../Buttons/LoadingButton';
import s from '../info.module.scss';
import { useGetIsBlockedBy } from '@hooks/TRPC_Hooks/useGetIsBlockedBy';
import { UnblockButton } from './UnblockButton';
import { useGetIsBlocked } from '@hooks/TRPC_Hooks/useGetIsBlocked';
const defaultButtonProps: Omit<ButtonProps, 'children' | 'id'> = {
  size: 'medium',
  color: 'Black'
};
interface Props {
  shortid: SocialManagerView.publicProfile['shortid'];
  isMyProfile: boolean;
  id: number;
}
export const RenderButton: FC<Props> = ({
  shortid,
  isMyProfile,
  id
}) => {
  const {
    status
  } = useSession();
  const {
    isLoading: isLoadingFollowing,
    data: isFollowing
  } = useIsFollowing({
    shortid
  }, {
    enabled: !isMyProfile,
    staleTime: 0,
    cacheTime: 0
  });
  const {
    isBlocked
  } = useGetIsBlocked({
    targetShortId: shortid
  });
  const {
    isBlocked: isBlockedBy
  } = useGetIsBlockedBy({
    targetShortId: shortid
  });
  const isLoading = !isMyProfile && status === 'authenticated' && isLoadingFollowing;
  const renderButton = useMemo(() => {
    if (isMyProfile) {
      return <EditButton {...defaultButtonProps} />;
    }
    if (isLoading) {
      return <LoadingButton {...defaultButtonProps} />;
    }
    if (isBlockedBy && !isBlocked) return null;
    if (isBlocked) {
      return <UnblockButton shortid={shortid} {...defaultButtonProps} />;
    }
    if (isFollowing) {
      return <FollowingButtons shortid={shortid} {...defaultButtonProps} />;
    }
    return <FollowButton shortid={shortid} {...defaultButtonProps} />;
  }, [isMyProfile, isLoading, isFollowing, isBlocked, isBlockedBy, id, shortid]);
  return <div className={s.info__buttons} data-sentry-component="RenderButton" data-sentry-source-file="RenderButton.tsx">
            {renderButton}
        </div>;
};